import { render } from "./SkillsPage.vue?vue&type=template&id=65bbba3a"
const script = {}

import exportComponent from "C:\\Users\\RebO\\Documents\\Github\\Projekt\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__